import { BORROWER_CREDIT_VALUE } from '.';

export enum MortgageDealItemType {
	Draft = 1,
	PendingForGuarantorConsent = 2,
	GuarantorConsented = 3,
	GuarantorRejected = 4,
	PendingAdminApproval = 5,
	PendingAdminApproval1 = 6,
	PendingDocumentsOrInformation = 7,
	DeclinedByPropCap = 8,
	WaitingConditionalOfferLetter = 9,
	WaitingConditionalOfferLetter1 = 10,
	WaitingConditionalOfferLetter2 = 11,
	WaitingConditionalOfferLetter3 = 12,
	WaitingConditionalOfferLetter4 = 13,
	WaitingConditionalOfferLetter5 = 14,
	WaitingConditionalOfferLetter6 = 15,
	WaitingConditionalOfferLetter7 = 16,
	WaitingConditionalOfferLetter8 = 17,
	WaitingConditionalOfferLetter9 = 18,
	WaitingConditionalOfferLetter10 = 19,
	RejectedConditionalOfferLetter = 20,
	SignConditionalOfferLetter = 21,
	payOfferAcceptanceFee = 22,
	AcceptanceFeePaid = 23,
	PendingSignTermSheet = 24
}

export const mortgageDealStatusName = {
	Draft: 'Draft',
	PendingForGuarantorConsent: 'Pending Guarantor’s consent',
	GuarantorConsented: 'Guarantor Consented',
	GuarantorRejected: 'Guarantor Rejected',
	PendingAdminApproval: 'Pending Admin Approval',
	PendingAdminApproval1: 'Pending Admin Approval',
	PendingDocumentsOrInformation: 'Pending documents/information',
	DeclinedByPropCap: 'Declined by PropCap',
	WaitingConditionalOfferLetter: 'Waiting Conditional Offer Letter',
	WaitingConditionalOfferLetter1: 'Waiting Conditional Offer Letter',
	WaitingConditionalOfferLetter2: 'Waiting Conditional Offer Letter',
	WaitingConditionalOfferLetter3: 'Waiting Conditional Offer Letter',
	WaitingConditionalOfferLetter4: 'Waiting Conditional Offer Letter',
	WaitingConditionalOfferLetter5: 'Waiting Conditional Offer Letter',
	WaitingConditionalOfferLetter6: 'Waiting Conditional Offer Letter',
	WaitingConditionalOfferLetter7: 'Waiting Conditional Offer Letter',
	WaitingConditionalOfferLetter8: 'Waiting Conditional Offer Letter',
	WaitingConditionalOfferLetter9: 'Waiting Conditional Offer Letter',
	WaitingConditionalOfferLetter10: 'Waiting Conditional Offer Letter',
	RejectedConditionalOfferLetter: 'Rejected Conditional Offer Letter',
	SignConditionalOfferLetter: 'Sign Conditional Offer Letter',
	payOfferAcceptanceFee: 'Pay Offer Acceptance Fee',
	acceptanceFeePaid: 'Offer Acceptance Fee Paid'
};
export const mortgageDealTypeMappers = new Map<MortgageDealItemType, string>();

mortgageDealTypeMappers.set(MortgageDealItemType.Draft, mortgageDealStatusName.Draft);
mortgageDealTypeMappers.set(
	MortgageDealItemType.PendingForGuarantorConsent,
	mortgageDealStatusName.PendingForGuarantorConsent
);
mortgageDealTypeMappers.set(MortgageDealItemType.GuarantorConsented, mortgageDealStatusName.GuarantorConsented);
mortgageDealTypeMappers.set(MortgageDealItemType.GuarantorRejected, mortgageDealStatusName.GuarantorRejected);
mortgageDealTypeMappers.set(MortgageDealItemType.PendingAdminApproval, mortgageDealStatusName.PendingAdminApproval);
mortgageDealTypeMappers.set(MortgageDealItemType.PendingAdminApproval1, mortgageDealStatusName.PendingAdminApproval1);
mortgageDealTypeMappers.set(
	MortgageDealItemType.PendingDocumentsOrInformation,
	mortgageDealStatusName.PendingDocumentsOrInformation
);
mortgageDealTypeMappers.set(MortgageDealItemType.DeclinedByPropCap, mortgageDealStatusName.DeclinedByPropCap);
mortgageDealTypeMappers.set(
	MortgageDealItemType.WaitingConditionalOfferLetter,
	mortgageDealStatusName.WaitingConditionalOfferLetter
);
mortgageDealTypeMappers.set(
	MortgageDealItemType.WaitingConditionalOfferLetter1,
	mortgageDealStatusName.WaitingConditionalOfferLetter1
);
mortgageDealTypeMappers.set(
	MortgageDealItemType.WaitingConditionalOfferLetter2,
	mortgageDealStatusName.WaitingConditionalOfferLetter2
);
mortgageDealTypeMappers.set(
	MortgageDealItemType.WaitingConditionalOfferLetter3,
	mortgageDealStatusName.WaitingConditionalOfferLetter3
);
mortgageDealTypeMappers.set(
	MortgageDealItemType.WaitingConditionalOfferLetter4,
	mortgageDealStatusName.WaitingConditionalOfferLetter4
);
mortgageDealTypeMappers.set(
	MortgageDealItemType.WaitingConditionalOfferLetter5,
	mortgageDealStatusName.WaitingConditionalOfferLetter5
);
mortgageDealTypeMappers.set(
	MortgageDealItemType.WaitingConditionalOfferLetter6,
	mortgageDealStatusName.WaitingConditionalOfferLetter6
);
mortgageDealTypeMappers.set(
	MortgageDealItemType.WaitingConditionalOfferLetter7,
	mortgageDealStatusName.WaitingConditionalOfferLetter7
);
mortgageDealTypeMappers.set(
	MortgageDealItemType.WaitingConditionalOfferLetter8,
	mortgageDealStatusName.WaitingConditionalOfferLetter8
);
mortgageDealTypeMappers.set(
	MortgageDealItemType.WaitingConditionalOfferLetter9,
	mortgageDealStatusName.WaitingConditionalOfferLetter9
);
mortgageDealTypeMappers.set(
	MortgageDealItemType.WaitingConditionalOfferLetter10,
	mortgageDealStatusName.WaitingConditionalOfferLetter10
);
mortgageDealTypeMappers.set(
	MortgageDealItemType.RejectedConditionalOfferLetter,
	mortgageDealStatusName.RejectedConditionalOfferLetter
);
mortgageDealTypeMappers.set(
	MortgageDealItemType.SignConditionalOfferLetter,
	mortgageDealStatusName.SignConditionalOfferLetter
);

mortgageDealTypeMappers.set(MortgageDealItemType.payOfferAcceptanceFee, mortgageDealStatusName.payOfferAcceptanceFee);

mortgageDealTypeMappers.set(
	MortgageDealItemType.AcceptanceFeePaid,
	mortgageDealStatusName.acceptanceFeePaid
);

export const ACCOUNT_TYPE = {
	CORPORATE: 'corporate',
	INDIVIDUAL: 'individual'
};

export const USE_OF_FUND = {
	NEW_PURCHASE_SELF_USE: '0',
	NEW_PURCHASE_BTL: '1',
	REFINANCE_SELF_USE: '2',
	REFINANCE_BTL: '3',
	OTHERS: '4'
};

export const OWNERSHIP = {
	JOIN_TENANCY: '0',
	TENANCY_IN_COMMON: '1',
	INDIVIDUAL_OWNERSHIP: '2',
	OTHERS: '3'
};


export const numberOfBedroomOptionWithNoneType = [
	{
		label: 'None',
		value: '-1'
	}
];

export const yesNoOptions = [
	{
		label: 'Yes',
		value: BORROWER_CREDIT_VALUE.YES
	},
	{
		label: 'No',
		value: BORROWER_CREDIT_VALUE.NO
	}
];


export const holdingTypeOptions = {
	FREE_HOLD: 'Free hold',
	LEASE_HOLD: 'Lease hold'
};

export enum MortgageDocumentTypeEnum {
	reservationOrMemorandumOfSaleDocument = 0,
	contractOfExchangeDocument = 1,
	titleFloorDocument = 2,
	ukFinanceDocument = 3,
	proofOfDepositDocument = 4,
	surveyorReportDocument = 5,
	existingMortgageStatementRentRollDocument = 6,
	existingTenancyDocument = 7,
	energyPerformanceDocument = 8,
	ews1FormDocument = 9,
	valuationDocument = 10,
	thirdPartyAgreementDocument = 11,
	othersDocument = 12,
	guarantorFileDocument = 13,
	reportOnTitleOrTitleDeedDocument = 14
}

export enum UseOfFundsTypeEnum {
	'New purchase self use' = 0,
	'New purchase BTL' = 1,
	'Refinance self use' = 2,
	'Refinance BTL' = 3,
	'Others' = 4
}

export const TYPE_FILTER_MORTGAGE_APPLICATION = {
	ALL_MORTGAGE_DEAL: 0,
	APPLICATION_IN_PROGRESS: 1,
	DECLINE: 2,
	CLOSED: 3
};

export const APPLICATION_IN_PROGRESS_LIST = [
	1, 2, 3, 4, 5, 6, 7, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22
];

export const DECLINE_VALUE = [8];

export const CLOSE_VALUE_MORTGAGE = [17];

export const PAYMENT_METHODS = {
	qfPay: 'QfPay',
	paypal: 'Paypal',
	bankTransfer: 'BankTransfer'
};

